import { BiSearch } from "react-icons/bi";
import { Input } from "../Input";

function SearchInput({
  value,
  setter,
  placeholder = "Search",
  customStyle,
  inputStyle,
  backgroundColor,
  iconColor = "var(--main-color)",
  onClick,
}) {
  return (
    <Input
      setter={setter}
      value={value}
      customStyle={{
        height: "36px",
        width: "320px",
        ...customStyle,
      }}
      inputStyle={{
        fontSize: "var(--fs-base)",
        border: "var(--input-border)",
        borderRadius: "var(--search-border-radius) !important",
        background: "var(--white-color)",
        ...inputStyle,
      }}
      placeholder={placeholder}
      leftIcon={
        <span
          style={{
            borderRadius: "50%",
          }}
          onClick={() => onClick && onClick()}
        >
          <BiSearch
            size={18}
            color={"#1E1E1E"}
            style={{
              marginTop: "0px",
              marginRight: "-10px",
              cursor: "pointer",
            }}
          />
        </span>
      }
      onEnter={onClick}
    />
  );
}

export default SearchInput;
